




























import { defineComponent } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import emitter from "@/lib/emitter";
import config from "@/config";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import FormatMoney from "@/components/FormatMoney";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import TransactionItem from "./TransactionItem.vue";

export default defineComponent({
  name: "BalanceView",
  components: {
    TransactionItem,
    FormatMoney,
    BasePage,
    BaseButton,
    PageTitle,
    EmptyContent,
    InfiniteScroll,
  },
  props: {
    loading: { type: Boolean, required: true },
    enableScroll: { type: Boolean, required: true },
    balance: { type: Number, required: true },
    transactionsList: { type: Array as () => Transaction[], required: true },
  },
  computed: {
    emptyTransactions(): boolean {
      return !this.loading && this.transactionsList.length === 0;
    },
    featureBalanceRefill() {
      return config.featureBalanceRefill;
    },
  },
  methods: {
    showRefill() {
      emitter.emit(EVENTS.BALANCE_REFILL_SHOW, true);
    },
  },
});
